<template>
  <div id="endcard">
    <h4 class="mb-3 word-bold">繳費確認...</h4>
    <hr>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
  </div>
</template>

<script>
import { apiQueryauth, apiFeeorderShoppay } from '../../Api/api'
import $ from 'jquery'
export default {
  created () {
    this.PostQueryauth()
  },
  methods: {
    PostQueryauth () { // 聯合信用卡_授權結果查詢 CC_ECPG_API002
      // 定義交易資料
      const vm = this
      const CardOK = JSON.parse(sessionStorage.getItem('CardOK'))
      const CardData = JSON.parse(localStorage.getItem('M_Identity'))
      if (!CardOK) { // 確認卡資料
        vm.$bus.$emit('Modals', '錯誤的繳費流程。')
        $('#CheckError').modal('show')
        vm.$router.push({ name: 'Feeorder_Personal' })
        return false
      }
      delete CardData.Token
      CardData.IntegratedSysId = '255' // 255: 多元繳費系統網頁
      CardData.Token = '9C2D3D654D8E495DBA5E38A0F8E20A32'
      CardData.CreditCardOrderId = CardOK.PayOrderId
      CardData.IsForeign = parseInt(sessionStorage.getItem('CardType')) // 國內
      CardData.TransAmt = CardOK.TotalAmt
      CardData.Data = CardOK.Data
      // 呼叫API
      apiQueryauth(CardData).then(
        res => {
          if (res !== undefined) {
            vm.PostFeeorderShoppay()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostFeeorderShoppay () { // 購物車繳費 F_API 012
      // 定義資料
      const vm = this
      const Identity = JSON.parse(localStorage.getItem('M_Identity'))
      delete Identity.ApplyDeptId
      const CardData = JSON.parse(sessionStorage.getItem('CardOK'))
      const PayUserData = JSON.parse(localStorage.getItem('PayUserData'))
      const NewData = Object.assign(Identity, CardData, PayUserData)
      NewData.PrintDT = ''
      NewData.PrintBarcode1 = ''
      NewData.PrintBarcode2 = ''
      NewData.PrintBarcode3 = ''
      NewData.PrintDebtNo = ''
      // 呼叫API
      apiFeeorderShoppay(NewData).then(
        res => {
          if (res !== undefined) {
            localStorage.removeItem('PayUserData')
            sessionStorage.removeItem('CardOK')
            sessionStorage.removeItem('CardType')
            vm.$bus.$emit('Modals', '交易成功')
            $('#CheckOk').modal('show')
            setTimeout(function () { // 延遲兩秒導向申請頁面，modal訊息會吃到申請頁面訊息，所以延遲避開
              vm.$router.push({ name: 'Feeorder_Personal' }) // 導向 證件申請頁面
            }, 2000)
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    }
  }
}
</script>
